import { useContext } from "react";
import { CompanyContext } from "./CompanyContext";
import { CompanyContextType } from "./types";

export function useCompany() {
  const company = useContext<CompanyContextType>(CompanyContext);
  return company;
}
